import type { ComputedRef, MaybeRefOrGetter } from 'vue';
import type { CollectionRead, DisplayTemplateAst, FieldSelection, ResolvedMonospaceCollection } from '#layers/data-model/public';
import { computed, toValue } from 'vue';
import { idFieldSelectionToFieldSelection, resolveCollectionDisplayTemplateSelection } from '#layers/data-model/public';
import { useFieldSelectionContexts } from './use-field-selection-contexts';

/** The fields to request for rendering `collection`'s rows, loaded through `read`, with their display template. */
export function useDisplayTemplateFieldSelection(
	collection: MaybeRefOrGetter<ResolvedMonospaceCollection | undefined>,
	read: CollectionRead,
	displayTemplate?: MaybeRefOrGetter<DisplayTemplateAst | undefined>,
): ComputedRef<FieldSelection> {
	const { fieldSelectionCtx, idCtx } = useFieldSelectionContexts();

	return computed<FieldSelection>(() => {
		const col = toValue(collection);
		if (!col) return { fields: ['*'] };

		const idSelection = resolveCollectionDisplayTemplateSelection(
			col,
			read,
			fieldSelectionCtx,
			toValue(displayTemplate),
		);

		return idFieldSelectionToFieldSelection(idSelection, idCtx);
	});
}
